import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "../../hooks/useAxiosClient";
import { TRootState } from "../../store";
import {
  setAllMarketsData,
  setDateRange,
  setFilteredMarkets,
  setMarketFiltersPanelOpenStatus,
} from "../../reducers/marketSlice";
import { toast } from "react-toastify";
import { TAllMarkets } from "../../types/markets/market";

const useMarkets = () => {
  const { handleGetCall } = useAxiosClient();
  const {
    adminId,
    dateRange,
    openMarketDetailsPanel,
    marketAddPanel,
    marketDetailsEditStatus,
    allMarketsData,
    filteredMarketsData,
    marketsFiltersPanelOpenStatus,
    marketFilters,
    refreshAllMarketsEntity,
    marketAddEditVal,
    roleType,
    marketUpdatedStatus,
    activeMarketTab,
  } = useSelector((state: TRootState) => ({
    adminId: state.auth.adminId,
    dateRange: state.marketDetails.dateRange,
    openMarketDetailsPanel: state.marketDetails.openMarketDetailsPanel,
    marketAddPanel: state.marketDetails.marketAddPanel,
    marketDetailsEditStatus: state.marketDetails.marketDetailsEditStatus,
    allMarketsData: state.marketDetails.allMarketsData,
    filteredMarketsData: state.marketDetails.filteredMarketsData,
    marketsFiltersPanelOpenStatus:
      state.marketDetails.marketsFiltersPanelOpenStatus,
    marketFilters: state.marketDetails.marketFilters,
    refreshAllMarketsEntity: state.marketDetails.refreshAllMarketsEntity,
    marketAddEditVal: state.marketDetails.marketAddEditVal,
    roleType: state.auth.userInfo?.roleType,
    marketUpdatedStatus: state.marketDetails.marketUpdatedStatus,
    activeMarketTab: state.marketDetails.activeMarketTab,
  }));
  const dispatch = useDispatch();
  const [allMarketsRefresh, setAllMarketsRefresh] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  const onChangeDateRangeNew = (fromDate: any, toDate: any, mode: any) => {
    if (fromDate !== dateRange.fromDate || toDate !== dateRange.toDate) {
      dispatch(
        setDateRange({ fromDate: fromDate, toDate: toDate, mode: mode })
      );
    }
  };

  const openStausFilter = (status: boolean) => {
    dispatch(setMarketFiltersPanelOpenStatus(status));
  };
  useEffect(() => {
    getAllMarkets();
  }, [refreshAllMarketsEntity, activeMarketTab]);

  const getAllMarkets = () => {

    let marketTypeVal = 1;

    if (activeMarketTab === "ALL") {
      marketTypeVal = 1;
    } else if (activeMarketTab === "PENDING") {
      marketTypeVal = 2;
    } else if (activeMarketTab === "REJECTED") {
      marketTypeVal = 3;
    }

    setLoading(true);
    handleGetCall<TAllMarkets[]>(
      `admin/markets/mpower/adminId/${adminId}?marketType=${marketTypeVal}`
    )
      .then(({ data }) => {
        if (data) {
          setLoading(false);
          dispatch(setAllMarketsData(data));
        } else {
          setLoading(false);
          dispatch(setAllMarketsData([]));
        }
        setAllMarketsRefresh(false);
      })
      .catch((err: any) => {
        setLoading(false);
        setAllMarketsRefresh(false);
        toast.error(err.response.data.status.description);
      });
  };
  const filterMarkets = () => {
    let filtered = allMarketsData || [];
    const trimmedSearchText = searchText
      .trim()
      .replace(/[\s.]+/g, "")
      .toLowerCase();
    if (searchText.length > 0) {
      filtered = filtered?.filter((option) => {
        const hasMarketNameMatch = option?.marketName
          .toString()
          .toLowerCase()
          .replace(/[\s.]+/g, "")
          .includes(trimmedSearchText);
        const hasmarketIdMatch = option?.marketId
          .toString()
          .toLowerCase()
          .replace(/[\s.]+/g, "")
          .includes(trimmedSearchText);
        const hasMandiHeadName =
          option?.employeeName &&
          option?.employeeName
            .toString()
            .toLowerCase()
            .replace(/[\s.]+/g, "")
            .includes(trimmedSearchText);
        return hasMarketNameMatch || hasmarketIdMatch || hasMandiHeadName;
      });
    }
    if (marketFilters.markets.length > 0) {
      filtered = filtered.filter((app) =>
        marketFilters.markets.some((m) => m.id === app.marketId)
      );
    }

    if (marketFilters.rms.length > 0) {
      filtered = filtered.filter((app) =>
        marketFilters.rms.some(
          (r) => r.label?.toLowerCase() === app?.employeeName?.toLowerCase()
        )
      );
    }
    if (
      marketFilters.status.length > 0 &&
      !marketFilters.status.includes("All")
    ) {
      filtered = filtered.filter((app) =>
        marketFilters.status.some(
          (lt) =>
            (app.status === 1 && lt.toLowerCase() === "active") ||
            (app.status === 0 && lt.toLowerCase() === "inactive") ||
            (app.status === 2 && lt.toLowerCase() === 'under review') ||
            (app.status === 3 && lt.toLowerCase() === 'rejected')
        )
      );
    }

    dispatch(setFilteredMarkets(filtered));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      filterMarkets();
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText, allMarketsData, marketFilters]);

  return {
    searchText,
    setSearchText,
    openStausFilter,
    onChangeDateRangeNew,
    dateRange,
    openMarketDetailsPanel,
    marketAddPanel,
    marketDetailsEditStatus,
    filteredMarketsData,
    allMarketsRefresh,
    setAllMarketsRefresh,
    allMarketsData,
    marketsFiltersPanelOpenStatus,
    marketAddEditVal,
    loading,
    roleType,
    activeMarketTab,
  };
};
export default useMarkets;
